var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"4"}},[_c('div',{staticClass:"text-h1",attrs:{"align":"center"}},[_vm._v("Twoja Praca")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }